import z from 'zod';
import { contentFileSchema, fileVotesSchema } from '../file.types';
import { subtitleSchema } from '../subtitle.types';
import { uploadCreateResponse } from './upload.responses';
import { FileStatus } from '../db/enums';
import { oaFileVotesSchema } from '../open-api/file.open-api.types';

export const fileSubtitlesFindResponse = z.array(subtitleSchema);
export type FileSubtitlesFindResponse = z.infer<typeof fileSubtitlesFindResponse>;

export const fileCreateResponse = uploadCreateResponse.extend({
    file: contentFileSchema
});
export type FileCreateResponse = z.infer<typeof fileCreateResponse>;

export const emptyFileCreationResponseSchema = fileCreateResponse.omit({
    links: true,
    uploadId: true
});
export type EmptyFileCreationResponse = z.infer<typeof emptyFileCreationResponseSchema>;

export const fileStatusResponseSchema = z
    .object({
        status: z.nativeEnum(FileStatus)
    })
    .merge(fileVotesSchema.partial({ voters: true }));

export type FileStatusResponse = z.infer<typeof fileStatusResponseSchema>;
